import React, { useState } from "react";
import CheckBox from "Components/common/CheckBox";
import { confirmationPopupState } from "Components/common/confirmationPopup";

const ExportActivitiesCheckBox = ({ onChange = () => {} }) => {
  const [checked, setChecked] = useState(false);
  return (
    <CheckBox
      id="exportHubspotActivities"
      name="Also export activities (emails, calls, LinkedIn and tasks)"
      checked={checked}
      cbk={value => {
        setChecked(value);
        onChange(value);
      }}
    />
  );
};

// Confirms a HubSpot contact export; onConfirm receives whether past activities should be exported too.
const confirmHubspotExport = (onConfirm = () => {}) => {
  let exportActivities = false;
  confirmationPopupState.setPopupValues({
    content: (
      <div className="hubspotExportConfirm">
        <div className="initText">Export the selected contacts to HubSpot?</div>
        <ExportActivitiesCheckBox
          onChange={value => {
            exportActivities = value;
          }}
        />
      </div>
    ),
    actionBtnText: "Export",
    callback: () => onConfirm(exportActivities),
    dynamicDom: true
  });
  confirmationPopupState.setShowPopup(true);
};

export default confirmHubspotExport;
